import * as React from "react";

const SendAltIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    {...props}
  >
    <path
      fill="#c80100"
      fillRule="evenodd"
      d="M15.719 8.421a7.3 7.3 0 1 1-7.3-7.3 7.3 7.3 0 0 1 7.3 7.3Zm-7.3 8.421A8.421 8.421 0 1 0 0 8.421a8.421 8.421 0 0 0 8.421 8.421ZM14.6 8.421a1.3 1.3 0 0 1-.045.2l-.011.022a1.422 1.422 0 0 1-.124.179l-4.494 4.483a.545.545 0 0 1-.393.168.564.564 0 0 1-.393-.168.555.555 0 0 1 0-.8l3.537-3.527h-9.87a.561.561 0 1 1 0-1.122h9.869L9.14 4.333a.563.563 0 0 1 .8-.8l4.491 4.492a.512.512 0 0 1 .124.179.44.44 0 0 1 .045.2Z"
    />
  </svg>
);

export default SendAltIcon;